import { Column, Row } from '@lightningjs/ui-components';
import { getProfilesAvatars } from '../../../../api/profiles';
import ChooseAvatar from '../components/ChooseAvatar';

export default async function (page, { profileId }) {
  try {
    const { data } = await getProfilesAvatars();

    const items = data.map((profile, index) => ({
      type: ChooseAvatar,
      w: 250,
      h: 250,
      src: profile.image_url,
      avatarId: profile.id,
      profileId: profileId,
      index: index,
      collision: true,
    }));

    // Create rows in parallel
    const pageItems = await Promise.all(
      Array.from({ length: Math.ceil(items.length / 5) }).map(async (_, i) => {
        const start = i * 5;
        const end = start + 5;
        const rowItems = items.slice(start, end).map((item, j) => {
          return { ...item, rowIndex: i, itemIndex: j };
        });

        // Create a row object with row information
        const rowObject = {
          type: Row,
          h: 250,
          collision: true,
          items: rowItems,
          style: {
            itemSpacing: 30,
          },
          rowIndex: i, // Add rowIndex here
        };

        return rowObject; // Return the row object
      })
    );
    page._Column.items = [];
    if (pageItems.length == 0) {
      page._Column.items = [];
    } else {
      if (page._Column) {
        page._Column.items = pageItems;
      } else {
        page._Column = { items: [] };
      }
    }
  } catch (error) {
    console.error('Error fetching avatars:', error);
  }
}
